export const SKYSCANNER_JHA = 'Skyscanner-JHA' as const;
